<template>
  <div class="masterbook_item">
    <!-- サムネイル -->
    <MbIndexThumbnailDisp :imageUrl="imageUrl" />
    <!-- サムネイル -->

    <div class="index-content-right">
      <!-- チケット名 -->
      <MbIndexNameDisp :name="name" />
      <!-- チケット名 -->

      <!-- 価格 -->
      <MbsStoreDisplayPriceDisp :price="price" />
      <!-- 価格 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemIndexMasterBook",

  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    price: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.masterbook_item {
  border-bottom: 1px solid #e0e0e0;
  background: white;
}
.index-content-right {
  overflow: hidden;
  padding-right: 16px;
  position: relative;
  height: 85px;
  padding-left: 2%;
}

@media screen and (min-width: 421px) {
  .index-content-right {
    height: 20vw;
  }
}
</style>
